<div class="card">
  <div class="card-body">
    <h5>Prescriber</h5>

    <app-prescriber-incorrect-information-prompt
      [client]="task.client"
      relatedRecordType="ClientConsultNoteTask"
      [relatedRecordId]="task.id"
      [prescriber]="task.prescriber" />

    <div class="row mb-2 pr-2">
      <div class="col">
        <div><strong>PRESCRIBER</strong></div>
        <div><app-prescriber-name [prescriber]="task.prescriber" /></div>
        <br />
        <div><strong>SPECIALTY</strong></div>
        <div>{{ task.prescriber.displaySpecialty }}</div>
      </div>
      <div class="col">
        <app-prescriber-offices-scrollable [prescriber]="task.prescriber" [acceptableFaxStatusOnly]="true" />
      </div>
    </div>
  </div>
</div>
<div class="card mt-2">
  <div class="card-body">
    <app-client-consult-note-task-referrals [task]="task" />
  </div>
</div>
<app-client-task-encounters [patient]="task.patient" />
<div class="card mt-2">
    <div class="card-body">
        <app-client-consult-note-task-related-tasks [task]="task" />
    </div>
</div>
